
export default class GalleryItemElement extends HTMLElement {
    constructor(){
        super();
    }
}

customElements.define('gallery-item', GalleryItemElement);